'use strict';

import util from "./../util";
import analytics from "../analytics";
import { isEmpty } from 'lodash-es';
import search from "../pages/search";
import crossSellTabs from "../pages/cross_sell_tabs";

var currentQuery = null,
	lastQuery = null,
	runningQuery = null,
	listTotal = -1,
	listCurrent = -1,
	delay = 30,
	searchSuggestioncallTimeout = null,
	$popularResultsContainer = $('.popular-search-overlay');


// Init slick slider for desktop
function updateSlickStyle() {
	crossSellTabs.init();
	var productSuggestionList = $('.product-suggestion-list');
	if ($(window).width() < 991) {
		productSuggestionList.css('width', $(window).width());
		if (productSuggestionList.hasClass('slick-initialized')) {
			productSuggestionList.slick('unslick');
		}
	} else if ($(window).width() >= 992) {
		productSuggestionList.removeAttr("style");
		setTimeout(() => {
			if ($('#einstein-product-results').length > 0 && productSuggestionList.find('.product-tile-outer').length > 3) {
				productSuggestionList.not('.slick-initialized').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
					prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>',
				});
			} else {
			}
		}, 300);
		$(document).on('click', '.slick-next, .slick-prev', function (e) {
			e.preventDefault();
		});
		if (productSuggestionList.hasClass('slick-initialized')) {
			$('.product-suggestion-wrapper').removeClass('autoHeight');
		}
	} else {
		productSuggestionList.removeAttr("style");
		if (productSuggestionList.hasClass('slick-initialized')) {
			productSuggestionList.slick('unslick');
		}
	}
}

/**
 * recent searches remove
 */
function removeRecentSearches() {
	// remove recent search keyword
	$('.search-redesign-container .recent-search-wrapper .cancel-result').on('click', function (e) {
		var removeTextSel = $(this).closest('li.item').attr('data-category');
		$(this).closest('li.item').remove();
		var recentText = util.getCookieValue('recentSearchSuggest');
		recentText = recentText ? decodeURIComponent(recentText) : '';		
		recentText = recentText.replace(/^["'](.+(?=["']$))["']$/, '$1'); //remove explicitly added strings
	
		var recentTextArray = recentText ? recentText.split(',') : [];
		var index = recentTextArray.indexOf(removeTextSel);
		if (index > -1) {
			delete recentTextArray[index];
		}
		var resultSet = recentTextArray.filter(function (el) {
		return el != null;
		});
		if(resultSet.length > 1) {
			$(".recent-search-cont .popular-search-title").text(Resources.RECENTSEARCHES);
		} else {
			$(".recent-search-cont .popular-search-title").text(Resources.RECENTSEARCH);
		}
		if(isEmpty(resultSet)) {
			util.setCookie('recentSearchSuggest','');
			$('.recent-search-cont').addClass("hide");
			$(".search-redesign-container.active").css("height", "670px");
		}else{
			let cookiesExp = SitePreferences.RECENT_SEARCH_COOKIES_EXP;//in secs
			cookiesExp =  Math.floor(cookiesExp / 60);//in minutes
			util.setCookie('recentSearchSuggest', encodeURIComponent(resultSet.join(',')), cookiesExp);
			$('.recent-search-cont').removeClass('hide');
		}
		
	});
}

var redesignSearchsuggest = {
	/**
	 * @function
	 * @description Configures parameters and required object instances
	 */
	init: function (container, defaultValue) {
		var searchContainer = $(container);
		var searchForm = searchContainer.find('form[name="simpleSearch"]');
		var searchField = searchForm.find('input[name="q"]');
		var submitButton = searchForm.find('button[type="submit"]');
		var cancelButton = searchForm.find('button[type="reset"]');

		// disable browser auto complete
		$('#suggestions-redesign-enabled').length > 0 && $('html').addClass('suggestions-enabled');
		$('#search-container .button-search').removeAttr('disabled');
		searchField.attr('autocomplete', 'off');

		//trigger click on hidden element
		$(document).find('.hidden-button-search-focus').on('click', function() {
			$('.search-text.hint-text').trigger('focus');
			$('.search-text.entered-text').trigger('focus');
		});

		// Search overlay Open
		$('#search-container .search-text.search-text-mobile').on('click', function (e) {
			e.preventDefault();
			this.showSearch();
			setTimeout(() => {
				$('body').hasClass('suggestions-wrapper_active') && analytics.searchOverlayShow();
				$('.hidden-button-search-focus').trigger('click');
			}, 0);
		}.bind(this));

		$('.button-search.nav-mobile-search, #search-container .button-search').on('click', function (e) {
			e.preventDefault();
			this.showSearch();
			setTimeout(() => {
				$('body').hasClass('suggestions-wrapper_active') && analytics.searchOverlayShow();
				$('.hidden-button-search-focus').trigger('click');
			}, 0);
		}.bind(this));

		// cancel button hide
		cancelButton.on('click', function (e) {
			e.stopPropagation();
			$('form[name="simpleSearch"] input[name="q"]').trigger('blur');
			lastQuery = null;
			runningQuery = null;
			currentQuery = null;
			cancelButton.hide();
			submitButton.prop('disabled', true);
			$(searchField).removeClass('active-style');
			runningQuery = null;
			currentQuery = null;
			this.popularSearch(runningQuery);
		}.bind(this));

		// on blur listener
		searchField.on('blur', function (e) {
			this.checkInput(e, searchField, submitButton, defaultValue);
			$('#q-hint').val('');
		}.bind(this));

		searchField.on('input', function () {
			$(searchField).addClass('active-style');
			if ($(this).val() != $('#q-hint').val()) {
				$('#q-hint').val('');
			}
		});

		// on key up listener
		searchField.off().on('keyup', function (e) {
			// get display cancel button on type
			if (searchField.val().trim().length > 0) {
				cancelButton.show();
			} else {
				// Hide hint text.
				$('#q-hint').val('');
				cancelButton.hide();
			}

			// get keyCode (window.event is for IE)
			var keyCode = e.keyCode;

			// check for an ENTER or ESC
			if (keyCode === 13 || keyCode === 27) {
				this.checkInput(e, searchField, submitButton, defaultValue);
				$('#q-hint').val('');
				return;
			}

			currentQuery = searchField.val().trim();
			clearTimeout(searchSuggestioncallTimeout);

			// no query currently running, init an update
			searchSuggestioncallTimeout = setTimeout(function () {
				if (currentQuery.length > 2 && lastQuery != currentQuery) {
					lastQuery = currentQuery;
					runningQuery = currentQuery;
					this.popularSearch(searchField.val().trim());
				} else if (currentQuery.length == 0) {
					this.popularSearch(null);
				}

			}.bind(this), 700);
		}.bind(this));

		submitButton.on('click', function (e) {
			e.preventDefault();
			var searchParam = $(searchForm).attr('action');
			window.location.href = searchParam.slice(searchParam.indexOf('/') + 3) + '?=' + searchForm.find('.entered-text').val();
			this.checkInput(e, searchField, submitButton, defaultValue);
			searchForm.submit();
		}.bind(this));

		// Search overlay Close
		$('.field-button-container .search-btn-close, .suggestions-overlay').on('click', function (e) {
			e.preventDefault();
			if($(window).width() > 991) {
				$('.search-btn-close').hide();
				$(".search-redesign-container").removeAttr('style')
			}
			$(".search-redesign-container").removeClass('active');
			(!$('.homepage-container').length > 0 && $(window).width() < 991) && $('.top-banner .button-search.show-for-small-only .search-btn-mobile').show();
			$('html').removeClass('modal-open');
			cancelButton.trigger('click');
			searchField.val('');
			setTimeout(() => {
				$('body').removeClass('suggestions-wrapper_active');
			}, 500);
			submitButton.prop('disabled', true);
		}.bind(this));

		$(document).on('keydown', function (e) {

			if (e.key === 'Enter' && $(document.activeElement).hasClass('search-text-mobile')) {
				$('#search-container .search-text.search-text-mobile').trigger('click');
				$('.simple-search-container').trigger('focus');
			}

			if (e.key === 'Enter' && $(document.activeElement).hasClass('search-btn-close')) {
				$('.field-button-container .search-btn-close, .suggestions-overlay').trigger('click');
				//remove focus from close button after closing search overlay

				if($('.marketing-banner').length > 0) {
					$('.marketing-banner a').blur();
				} else {
					$('#main').find('a, button').first().blur();
				}
			}
		});

		$('.search-btn').on('click', function (e) {
			e.preventDefault();
			if($(window).width() > 991) {
				$('.search-btn-close').hide();
				$(".search-redesign-container").removeAttr('style')
			}
			$(".search-redesign-container").removeClass('active');
			(!$('.homepage-container').length > 0 && $(window).width() < 991) && $('.top-banner .button-search.show-for-small-only .search-btn-mobile').show();
			$('html').removeClass('modal-open');	
			setTimeout(() => {
				$('body').removeClass('suggestions-wrapper_active');
			}, 500);
			submitButton.prop('disabled', true);
		}.bind(this));

		$(window).on('resize orientationchange', function () {
			updateSlickStyle();
			checkToInitSlickSlider();
			searchOverlayMobileSlider();
			$(window).width() < 991 && $('.search-btn-close').removeAttr('style');
		});

	},
	checkInput: function (e, searchField, submitButton, defaultValue) {
		if (searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()) {
			e.stopImmediatePropagation();
			searchField.val(defaultValue);
			return false;
		}
	},
	showSearch: function () {
		var searchContainer = $('.search-redesign-container');
		(!$('.homepage-container').length > 0 && $(window).width() < 991) && $('.top-banner .button-search.show-for-small-only .search-btn-mobile').hide();
		$('body').addClass('suggestions-wrapper_active');
		$('html').addClass('modal-open');
		$(window).width() > 991 && $('.search-btn-close').show();
		setTimeout(() => {
			searchContainer.addClass('active');
			if($('.popular-suggestion-container').length <=0) {
				$('.ajax-loader.searchoverlay-loader').show();
			}
		}, 100);
		runningQuery = null;
		currentQuery = null;
		this.popularSearch(runningQuery);
		$('.hidden-button-search-focus').trigger('click');
	},
	/**
	 * @function
	 * @description: execute server call for popular search
	 */
	popularSearch: function (query) {
		var popularSearchUrl = util.appendParamsToUrl(Urls.searchsuggest, { 'q': query, 'format': 'ajax' });
		$.get(popularSearchUrl, function (data) {
			$('.search-redesign-container').find('.entered-text').focus();
			$popularResultsContainer.html(data);
			updateSlickStyle();
			checkToInitSlickSlider();
			searchOverlayMobileSlider();
			var searchContainer = $('.search-redesign-container');
			$('#search-container .search-text-mobile').val('');
			var productTile = $('.product-suggestion-wrapper .product-suggestion-list .product-tile-outer');
			$(productTile).length > 4 && $('.product-suggestion-wrapper').addClass('autoHeight');
			$('.product-no-result').length > 0 && $('.product-suggestion-wrapper').addClass('autoHeight');
			$('.no-search-result').length > 0 ? searchContainer.addClass('no-result') : searchContainer.removeClass('no-result')
			
			// Wait for product tiles to be fully loaded before setting tabindex
			util.waitForElement('.product-suggestion-wrapper .product-suggestion-list .product-tile-outer').then(function() {
				const productTile = $('.product-suggestion-wrapper .product-suggestion-list .product-tile-outer');
				productTile.each(function () {
					const $section = $(this);
					$section.find('a, button, input, a.thumb-link').not('a.product-tile-wrapper').attr('tabindex', '-1');
				});
			}).catch(function(err) {
				console.warn('Product tiles did not load in time:', err);
			});
			if($(window).width() > 991) {
				$('#search-product-results').length > 0 ? searchContainer.css('height', $(window).innerHeight() - 60 + 'px') : searchContainer.removeAttr('style');
				if($(".recent-search-wrapper").length || $(".search-results-appeared").length) {
					$(".search-redesign-container.active").css("height", "780px");
				} else {
					$(".search-redesign-container.active").css("height", "670px");
				}

				if($(".recent-search-wrapper").length && $('.no-search-result').length) {
					$(".search-redesign-container.active").css("height", "780px");
				}
			}
			// analytics datalayer for Search Overlay
			setTimeout(() => {
				$('body').hasClass('suggestions-wrapper_active') && analytics.searchEinstienProductList();

				$(".search-redesign-container .product-tile-outer .product-tile").on('click', function (e) {
					analytics.searchProductTile($(this));
				});

				$(".search-redesign-container .popular-search-list a, .search-redesign-container .category-wrapper a, .search-redesign-container .suggestion-wrapper a, .search-redesign-container .suggestion-header .link").on('click', function (e) {
					analytics.searchCategoryLink($(this));
				});
				removeRecentSearches(); 
			}, 0);
			// load first tab content
			$(".suggestions-container .top-tabs-wrapper .tab:first-child button.cs-tab").trigger("click");
		})
		.done(function() {
			$('.ajax-loader.searchoverlay-loader').hide();
		})
		.fail(function() {
		// Hide the loader even if the request fails
			$('.ajax-loader.searchoverlay-loader').hide();
		// Handle the error
		}).always(function () {
			$('.ajax-loader.searchoverlay-loader').hide();
		})
	}
};

// search overlay Mobile carousel initialization 
function searchOverlayMobileSlider() {
	if($('#einstein-product-results').length && $(window).width() < 991) {
		var searchOverlaySelector = $('.popular-suggestion-wrapper .product-suggestion-list');
		// OverlayScrollbars initialization with an element
		searchOverlaySelector.each(function (index, ele) {
			var osInstance = OverlayScrollbars($(ele), {});
		});
	} else {
		var searchOverlaySelector = $('.popular-suggestion-wrapper .product-suggestion-list');
		searchOverlaySelector.each(function (index, ele) {
			var osInstance = OverlayScrollbars($(ele), {}).destroy(); // Disable for desktop screen
		});
	}
}

function updateMobileSlider() {
	$('.popular-suggestion-container.search-results-appeared .product-item .product-slick-track').each(function () {
		if($(this).find("ul.slick-dots li").length <=2 ) {
			$(this).find("ul.slick-dots").hide();
		}
	});
}

function checkToInitSlickSlider() {
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	if(isDesktop && $('#einstein-product-results').length > 0 && !window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
		search.initPLPSlider(true);
	}
	if($('#einstein-product-results').length <= 0) {
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
			search.initPLPSlider(true);
		}
		updateMobileSlider();
	}
}

export default redesignSearchsuggest;


